import {Box, Flex} from "@chakra-ui/react";
import PageLoader from '../../../global/components/helper-components/components/PageLoader';
import LaunchdeckButton from '../../../global/components/helper-components/components/LaunchdeckButton';
import LaunchdeckFormInput from '../../../forms/TextInputField/components/LaunchdeckFormInput';


export function CreateProspectDsrForm({
  prospectorTitleInput,
  error,
  showLoader,
  onChangeHandler,
  handleClickCloseEditActionModal,
  handleCreateNewProspectDsr,
}) {
  
  const titleCharacterLimit = 100;


  if (showLoader) {
    return (
      <Box w="100%" align="center" >
        <Box px='1em'>
          <PageLoader />       
        </Box>
      </Box>
    )
  } else {
    return (
      <Flex direction='column' m='24px' w="100%" align="center" justify='space-between' >
        <Box w='100%' mb='24px'>
            <LaunchdeckFormInput
							label='Prospector name'
							name={'dsrTitle'}
							onChange={onChangeHandler}
							value={prospectorTitleInput}
							placeholder={'Give your Prospector a good name'}
							isRequired={true}

              charLimit={titleCharacterLimit}

							errorLogic={error === 'dsrTitle'}
							errorMessage={'Give it a good name'}
						/>

        </Box>

        <Flex w='100%' mt='2em' py='0.625em'>
          <Flex justify='space-between' w='100%'>
            <LaunchdeckButton bg='gray.200' color='brandDark.500' onClick={handleClickCloseEditActionModal} label='Cancel' />
            <LaunchdeckButton bg='brand.500' color='white' onClick={handleCreateNewProspectDsr} label='Create Prospector' />
          </Flex>
        </Flex>
      </Flex>
    )
  }
}
